import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { colors } from "src/styles/theme";
import styled, { css } from "styled-components";

type BoxType = "box" | "round";
export default function useRadioBoxGroup(args: {
  multipleValue?: boolean;
  items: { id: number; name: string; fontSize?: string }[];
  defaultSelectedIds?: number[];
  rowCount?: number;
  multiLineColumnCount?: number;
  subSelectIds?: number[];
  boxType?: BoxType;
  checkBoxType?: boolean;
  readOnly?: boolean;
  fontSize?: string;
}) {
  const [activeIds, setActiveIds] = useState(() => {
    if (!args.defaultSelectedIds) {
      return;
    }
    if (((args.defaultSelectedIds && args.defaultSelectedIds?.length) ?? -1) > 0) {
      if (args.multipleValue) {
        return [...args.defaultSelectedIds];
      }
      return [args.defaultSelectedIds?.[0]];
      // return [...args.defaultSelectedIds]
    }
    return;
  });

  useEffect(() => {
    if (args?.defaultSelectedIds) {
      setActiveIds(args?.defaultSelectedIds);
    }
  }, [JSON.stringify(args?.defaultSelectedIds)]);

  function RadioBoxGroup() {
    const boxType = args?.boxType ?? "box";
    return (
      <Container
        $checkBoxType={args.checkBoxType}
        $boxType={boxType}
        $multiLineColunCount={args.multiLineColumnCount}
        $readOnly={args.readOnly}
        $fontSize={args.fontSize}
      >
        {args.items.map((item, idx) => {
          return (
            <div
              style={{ fontSize: item.fontSize ?? "" }}
              className={`box ${activeIds?.includes(item.id) ? "active" : ""}`}
              key={`${"key1"}-${item.id}-${idx}`}
              onClick={(e) => {
                e.preventDefault();
                if (activeIds?.includes(item.id)) {
                  setActiveIds((ids) => {
                    const new1 = ids?.filter((id) => id !== item.id);
                    return new1;
                  });
                } else {
                  if (!args.multipleValue) {
                    setActiveIds([item.id]);
                  } else {
                    setActiveIds((ids) => [...(ids ?? []), item.id]);
                  }
                }
              }}
            >
              {args.checkBoxType ? (
                <>
                  {" "}
                  <FaCheck className={activeIds?.includes(item.id) ? "active" : ""} />{" "}
                </>
              ) : (
                <>{item.name}</>
              )}
              {}
            </div>
          );
        })}
      </Container>
    );
  }

  return { RadioBoxGroup, activeIds };
}

const Container = styled.div<{
  $boxType: BoxType;
  $rowCount?: number;
  $multiLineColunCount?: number;
  $checkBoxType?: boolean;
  $readOnly?: boolean;
  $fontSize?: string;
}>`
  ${(p) => {
    if (p.$multiLineColunCount) {
      return css`
        display: grid;
        grid-template-columns: repeat(${p.$multiLineColunCount}, 1fr);
        gap: 8px;
      `;
    }
    return css`
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    `;
  }}

  ${(p) => {
    if (p.$readOnly) {
      return css`
        pointer-events: none;
      `;
    }
    return "";
  }}

  .box {
    display: flex;
    height: 44px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-family: Pretendard, -apple-system, Roboto, Helvetica, sans-serif;
    font-size: ${(p) => p.$fontSize || "14px"};
    line-height: 18px;
    flex: 1;
    min-width: 0;
    background: #f0f0f4;
    color: #1a1a1a;
    font-weight: 400;
    transition: all 0.2s ease;

    /* 4개 미만일 때만 패딩 적용 */
    ${(p) => {
      if (p.$multiLineColunCount && p.$multiLineColunCount <= 4) {
        return css`
          padding: 13px 16px;
        `;
      }
      return css`
        padding: 0;
      `;
    }}

    &.active {
      background: #007bff;
      color: #fdfdfd;
    }

    &:hover {
      filter: brightness(0.95);
    }
  }

  ${(p) => {
    if (p.$checkBoxType) {
      return css`
        .box {
          background-color: #fff;
          svg {
            color: ${colors.gray.third};
          }
          &.active {
            background-color: #fff;
            svg {
              color: ${colors.green.first};
            }
          }
        }
      `;
    }
    return css``;
  }}
`;
